export const getParamFromUrlQueryString = (url: string, param: string): string | undefined => {
  const params = new URL(url).searchParams;
  return params.get(param) ?? undefined;
};
